import { push } from 'connected-react-router';
import webAuth from '../../utils/auth';
import { SET_CURRENT_USER, SET_RETURN_URL, } from './constants';
import { error } from '../../utils/notifications';

export const setCurrentUser = (user) => {
  return {
    type: SET_CURRENT_USER,
    payload: user,
  };
};

export const changeReturnUrl = url => ({
  type: SET_RETURN_URL,
  payload: url,
});

export default (values, dispatch, props) => {
  return new Promise((resolve, reject) => {
    webAuth.login({
      realm: process.env.REACT_APP_AUTH_CONNECTION,
      username: values.email,
      password: values.password,
    }, (err, res) => {
      if (err) {
        error(err.description);
        reject(err);
      }
      if (res) {
        resolve(res);
        dispatch(push('/auth'));
      }
    });
  });
};
